import { render, staticRenderFns } from "./OrderDetailCard.vue?vue&type=template&id=36be5477&scoped=true&"
import script from "./OrderDetailCard.vue?vue&type=script&lang=js&"
export * from "./OrderDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailCard.vue?vue&type=style&index=0&id=36be5477&prod&lang=scss&"
import style1 from "./OrderDetailCard.vue?vue&type=style&index=1&id=36be5477&prod&lang=scss&scoped=true&"
import style2 from "./OrderDetailCard.vue?vue&type=style&index=2&id=36be5477&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be5477",
  null
  
)

export default component.exports